<template>
  <div :class="$style.root">
    <core-image-component
      :image="data?.image"
      :class="$style.image"
    />

    <shared-participants-link-to-modal-component
      :id="data?.id"
      :class="$style.link"
    >
      {{ participant?.title }}
    </shared-participants-link-to-modal-component>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const participant = formatParticipantHeadingObject(props.data)
</script>

<style module>
.root {
  position: relative;
}

.image {
  --base--image--height: var(--100svh);
}

.link {
  composes: font-size-large from global;

  position: absolute;

  max-width: calc(100% - var(--unit--horizontal) * 2);
  bottom: var(--unit--vertical);
  left: var(--unit--horizontal);

  padding: var(--padding--element);

  background-color: var(--color--background);
}
</style>
